import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { XosLogoAppearance } from '../../constants/core-appearances.type';
import { Router } from '@angular/router'

const LOGO_PATH = '/assets/logos/';
@Component({
  selector: 'xos-company-logo',
  imports: [CommonModule],
  templateUrl: './xos-company-logo.component.html',
  styleUrls: ['./xos-company-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class XosCompanyLogoComponent implements OnInit {
  @Input() appearance!: XosLogoAppearance;
  @Input() height: number = 48;

  appLogo = LOGO_PATH + 'logo-01.png';

  constructor(private router: Router) {
  }

  ngOnInit(): void {
    if (this.router.url.includes('allen')) {
      this.appLogo = LOGO_PATH + 'shop_logo_xo_allen.png';
    } else if (this.appearance === 'white') {
      this.appLogo = LOGO_PATH + 'logo-02.png';
    }
  }

}
